// Alliant Program Variables
export const tcwVariables: any = {
    programTitle: "TCW LLC",
    effectiveDates: "11/15/2022 - 11/15/2023",
    feeDisclaimer: null,
    EL_Included: "$2,000,000",
    EL_Items: [
        "TCW_EL_Header",
        ["TCW_EL_2M", "$2,000,000", "$1,058"],
        ["TCW_EL_3M", "$3,000,000", "$1,111"],
        ["TCW_EL_5M", "$5,000,000", "$1,366"],
        ["TCW_EL_10M", "$10,000,000*", "$2,227"],
        ["TCW_EL_15M", "$15,000,000**", "$3,258"],
        ["TCW_EL_20M", "$20,000,000**", "$5,716"],
        ["TCW_EL_25M", "$25,000,000**", "$8,318"],
        ["TCW_EL_30M", "$30,000,000**", "$11,927"],
        ["TCW_EL_40M", "$40,000,000**", "$20,019"],
        ["TCW_EL_50M", "$50,000,000**", "$27,610"]
    ],
    EL_Disclaimers: [
        "<strong>*</strong>The maximum limit of liability for any participants without their underlying home and auto insurance policies in place with Chubb.",
        "<strong>**</strong>It is a requirement that any participant who <u>newly elects or enrolls</u> at these limits have their underlying home and auto insurance policies in place with Chubb and complete the Group Personal Excess Participants Questionnaire.  These limits are subject to prior underwriting approval.  These requirements have been waived for current participants renewing at their expiring limit."
    ],
    UM_Items: [
        "TCW_UM_Header",
        ["TCW_UM_2M", "$2,000,000", "Included above"],
        ["TCW_UM_3M", "$3,000,000", "$119"],
        ["TCW_UM_5M", "$5,000,000", "$353"]
    ],
    UM_Disclaimers: ["*The UM/UIM limit cannot be higher than the liability limit."],
    EPLI_Items: [
        "TCW_EP_Header",
        ["TCW_EP_Decline", "By selecting this box, I am declining EPLI Insurance."],
        ["TCW_EP_250K", "$250,000 per occurrence / $500,000 aggregate*", "$10,000", "$789"],
        ["TCW_EP_500K", "$500,000 per occurrence / $500,000 aggregate*", "$10,000", "$1,183"]
    ],
    EPLI_Disclaimer: "<strong>*</strong>Any participant who newly elects this coverage is required to complete the Chubb Employment Practice Liability Coverage Request Worksheet.",
    CI_Items: [
        "TCW_CI_Header",
        "TCW_CI_Yes",
        "TCW_CI_No"
    ]
};

